import React, { useContext, useState } from 'react';
import useFormProcessor from '../../hooks/useFormProcessor';
import { useHistory } from 'react-router-dom';

import { setCookie } from '../../utils/cookie';

import { Context } from '../../providers/global-context.provider';
import { loginUser,getCaptcha } from '../../services/users.service';
import { getEmptyInputsErrorsObject } from '../../utils/errors/auth';

import ErrorMessageContainer from '../form-input-error-message';
import FormInput from '../form-input';
import FormButton from '../button-form';

const initialUser = {
	username: '',
	password: '',
	captchaText: '',
	captchaToken: '',
	captchaImgUrl: '',
	captchaInputText: ''
};

const SignInForm = () => {
	const { data, errors, setErrors, handleChange, handleSubmit,setData } = useFormProcessor(initialUser, initialUser);
	const { toggleLoggedIn, saveUser } = useContext(Context);
	const history = useHistory();

	const getErrors = () => {
		const { username, password, captchaInputText  } = data;
		// console.log(username, password, captchaInputText,captchaText, captchaToken);
		return getEmptyInputsErrorsObject({ username, password, captchaInputText });
	};

	const handleSignIn = async () => {
		// console.log('handleSignIn',data);
		const result = await loginUser({ ...data });
		if (result.AccessToken) {
			saveUser(result.User);
			setCookie('x-auth-token', result.AccessToken);
			setErrors(initialUser);
			toggleLoggedIn(true);
			history.push('/user/projects');
		} else {
			await doRefresh();
			setErrors({ ...errors, password: 'نام کاربری یا رمزعبور صحیح نمی باشد' });
			
		}
	};

	const doRefresh = async () => {
		const res = await getCaptcha();

		setData({ ...data, captchaText: res.CaptchaTextValue, captchaToken: res.CaptchaTokenValue, captchaImgUrl: res.CaptchaImgUrl });
		setErrors({ ...errors, captchaText: '', captchaImgUrl: '', captchaToken: '' });

	};

	window.addEventListener('load', ()=>{
		doRefresh();
	});

	return (
		<form
			onSubmit={(e) => handleSubmit(e, getErrors(), handleSignIn)}
			className="lg:w-2/6 md:w-1/2 rounded-lg p-8 flex flex-col md:ml-0 w-full mt-10 md:mt-0"
		>
			<h2 className="text-gray-900 text-lg font-medium title-font mb-5">ورود به پنل کاربری</h2>
			<FormInput handleChange={handleChange} type="text" name="username" value={data.username} placeholder="کدملی" />
			{errors.username ? <ErrorMessageContainer>{errors.username}</ErrorMessageContainer> : null}
			<FormInput
				type="password"
				name="password"
				placeholder="رمز عبور"
				value={data.password}
				handleChange={handleChange}
			/>
			{errors.password ? <ErrorMessageContainer>{errors.password}</ErrorMessageContainer> : null}
			<div className="row">
				<div className="col-4"></div>
				<img src={data.captchaImgUrl}
					className="mb-4" />
				<a className="fa fa-refresh btn-sm cursor-pointer"
                	onClick={doRefresh}></a>

			</div>
			<FormInput
				type="number"
				name="captchaInputText"
				placeholder="لطفا کد را وارد کنید"
				value={data.captchaInputText}
				handleChange={handleChange}
			/>
			{errors.captchaInputText ? <ErrorMessageContainer>{errors.captchaInputText}</ErrorMessageContainer> : null}
			<FormButton addClass="mt-4">ورود</FormButton>
		</form>
	);
};

export default SignInForm;
